// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  padding: 36px 0 83px 0;
  float: left;
  width: 100%;
  display: flex;
  justify-content: center;

  @media (max-width: 1100px) {
    padding: 36px 25px 83px 25px;
    width: calc(100% - 50px);
    justify-content: space-between;
  }
  @media (max-width: 700px) {
    margin: 30px 23px;
    padding: 170px 0 30px 0;

    width: calc(100% - 46px);
    position: relative;
  }
`;

class SetThreeIcons extends Component {
  render() {
    return (
      <Wrapper>
        {this.props.set.map(item => (
          <ThreeIcons content={item} key={item.id} />
        ))}
      </Wrapper>
    );
  }
}

export default SetThreeIcons;

const Item = styled.div`
  padding: 18px;
  width: 310px;
  position: relative;
  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 310, 226, "vw")};
    padding: 0;
  }
  @media (max-width: 700px) {
    width: calc(50% - 10px);

    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;

    :first-child {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      ::after {
        content: "";
        border-bottom: solid 1px #e5e5e5;
        width: calc(50% - 80px);
        position: absolute;
        left: 0;
        top: 55px;
      }
      ::before {
        content: "";
        border-bottom: solid 1px #e5e5e5;
        width: calc(50% - 80px);
        position: absolute;
        right: 0;
        top: 55px;
      }
    }
  }
`;
const Image = styled.div`
  height: 204px;
  width: 204px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  top: 18px;
  left: ${53 + 18}px;
  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 204, 146, "vw")};
    width: 100%;
    left: 0;
    top: 0;
    position: relative;
    float: left;
  }
  @media (max-width: 700px) {
    height: 110px;
    width: 110px;
  }
`;
const TitleContainer = styled.div`
  padding-top: 224px;
  height: 58px;
  width: 100%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1100px) {
    padding-top: 23px;
    height: ${scale(1100, 767, 58, 52, "vw")};
  }
  @media (max-width: 700px) {
    padding-top: 10px;
    height: auto;
  }
`;
const Title = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.22;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    line-height: ${scale(1100, 767, 18 * 3.22, 18 * 1.39, "vw")};
  }
  @media (max-width: 800px) {
    line-height: 1.39;
  }
  @media (max-width: 700px) {
    max-width: 150px;
    font-size: 12.6px;
    line-height: 1.39;
    letter-spacing: 0.2px;
  }
`;

class ThreeIcons extends ArticleAbstract {
  render() {
    return (
      <Item {...this.link()}>
        <Image style={this.image()} />
        <TitleContainer>
          <Title>{this.title()}</Title>
        </TitleContainer>
      </Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetThreeIcons.js